import React, {useState} from 'react';
import {Row, Col} from 'antd';
import Breadcrumb from './Breadcrumb';
import TabContainer from './TabContainer';
import Information from './Information';
import Navbar from './Navbar';
import useProfileLayout from '../../hooks/use-profile-layout';
import {navigate} from 'gatsby';

function ProfileLayout({pathname, children, tabName}) {
  const {parent, tab} = useProfileLayout({pathname, tabName});

  return (
    <Row gutter={20}>
      <Col md={4} xs={24}>
        <Navbar pathname={pathname} />
      </Col>
      <Col md={1} xs={24} style={{height: 20}}></Col>
      <Col md={19} xs={24}>
        <Breadcrumb entry={parent} leafNode={tab} />
        <Information />
        <TabContainer
          entry={parent}
          leafNode={tab}
          onTabClick={(entry) => navigate(`${pathname}?tabName=${entry.name}`)}>
          {children({tab})}
        </TabContainer>
      </Col>
    </Row>
  );
}

export default ProfileLayout;
export {Breadcrumb, TabContainer, Information, Navbar};
